import { useQuery } from '@tanstack/react-query';
import { fetchTables, fetchTableSchema } from '../api/mysql';

export function useTables(dbName: string | null) {
  return useQuery({
    queryKey: ['mysql', 'tables', dbName],
    queryFn: () => fetchTables(dbName!),
    enabled: !!dbName,
  });
}

export function useTableSchema(dbName: string | null, tableName: string | null) {
  return useQuery({
    queryKey: ['mysql', 'schema', dbName, tableName],
    queryFn: () => fetchTableSchema(dbName!, tableName!),
    enabled: !!dbName && !!tableName,
  });
}
